/** The properties listed below are global computed properties available 
 *  under Vue.$globals.propertyName, e.g. this.$globals.travellers
 */
import Vue from "vue";
import { store } from '../store/store';

export default {
  
  airports() {
    return store.state.bookTravel.airports;
  },
  vendors() {
    return store.state.bookTravel.vendors;
  },
  travellers() {
    return store.getters["travellersAndTrips/getTravellers"];
  },
  airlineNames() {
    return store.state.bookTravel.vendors.airlines;
  },
  profile() {
    return store.state.travellersAndTrips.profile;
  },
  currentTravellerProfile() {
    return store.getters["travellersAndTrips/getCurrentTravellerProfile"];
  },
  ticketAirlines() {
    if (store.state.travellersAndTrips.profile.unusedTicketAirlines) {
      return store.state.travellersAndTrips.profile.unusedTicketAirlines;
    } else {
      return [];
    }
  },
  travellerProfile() {
    return store.getters["travellersAndTrips/getCurrentTravellerProfile"];
  },
  cityCodes() {
    return {
            'ATL':'Atlanta',
            'BOS':'Boston',
            'CHI':'Chicago',
            'Dallas':'Dallas',
            'DEN':'Denver',
            'LAS':'Las Vegas',
            'LAX':'Los Angeles',
            'MIA':'Miami',
            'BNA':'Nashville',
            'NYC':'New York',
            'SFO':'San Francisco',
            'SEA':'Seattle',
            'WAS':'Washington DC'
    }
  }
};
